import { useState } from "react";
import { floorUpdates } from "@/mocks/gossip";

const toneDot: Record<string, string> = {
  accent: "bg-accent-500",
  primary: "bg-primary-500",
  secondary: "bg-secondary-500",
};

export default function FloorUpdates() {
  const [liked, setLiked] = useState<Record<number, boolean>>({});
  const [text, setText] = useState("");

  return (
    <section id="floor" className="mx-auto max-w-[1240px] px-4 py-10 md:px-6 md:py-12">
      <div className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
        <div className="flex flex-col gap-3 border-b border-background-200 bg-background-50 px-5 py-4 md:flex-row md:items-end md:justify-between md:px-7">
          <div>
            <div className="mb-1 flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-primary-700">
              <i className="ri-stack-fill"></i>楼层跟进
            </div>
            <h2 className="font-heading text-xl font-black text-foreground-950 md:text-2xl">新进展 · 更新随时顶上来</h2>
            <p className="mt-1 text-sm text-foreground-600">蹲住的楼，最新几条进展实时置顶，和瓜友一起等后续。</p>
          </div>
          <div className="flex shrink-0 items-center gap-2">
            <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
              <i className="ri-eye-line mr-1"></i>1.6w 瓜友在蹲
            </span>
            <span className="rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-900">
              <i className="ri-stack-line mr-1"></i>已盖 3186 楼
            </span>
          </div>
        </div>

        <div className="divide-y divide-background-200 px-5 md:px-7">
          {floorUpdates.map((u) => {
            const isLiked = !!liked[u.floor];
            return (
              <article key={u.floor} className="flex gap-3 py-4 md:gap-4">
                <span
                  className={
                    "flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-sm font-bold text-background-50 " +
                    (u.tone === "primary" ? "bg-primary-500" : u.tone === "accent" ? "bg-accent-500 text-foreground-950" : "bg-secondary-500")
                  }
                >
                  {u.by.slice(0, 1)}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
                    <span className="font-medium text-foreground-900">{u.by}</span>
                    <span className={"flex items-center gap-1 " + (u.tone === "accent" ? "text-accent-700" : u.tone === "primary" ? "text-primary-700" : "text-secondary-700")}>
                      <i className={"h-1.5 w-1.5 rounded-full " + toneDot[u.tone]}></i>第 {u.floor} 楼
                    </span>
                    <span className="inline-flex items-center gap-1"><i className="ri-time-line"></i>{u.time}</span>
                  </div>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-800">{u.text}</p>
                  <div className="mt-2 flex items-center gap-4 text-xs text-foreground-500">
                    <button
                      onClick={() => setLiked((s) => ({ ...s, [u.floor]: !s[u.floor] }))}
                      className={
                        "inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-1 transition " +
                        (isLiked ? "bg-primary-100 text-primary-700" : "hover:bg-background-200")
                      }
                    >
                      <i className={isLiked ? "ri-heart-fill" : "ri-heart-line"}></i>
                      {isLiked ? u.likes + 1 : u.likes} 顶
                    </button>
                    <button className="inline-flex items-center gap-1 whitespace-nowrap hover:text-primary-700">
                      <i className="ri-chat-1-line"></i>回复 {u.replies}
                    </button>
                    <button className="inline-flex items-center gap-1 whitespace-nowrap hover:text-primary-700">
                      <i className="ri-share-line"></i>分享楼层
                    </button>
                  </div>
                </div>
              </article>
            );
          })}
        </div>

        <div className="border-t border-background-200 px-5 py-4 md:px-7">
          <form
            onSubmit={(e) => e.preventDefault()}
            className="flex flex-col gap-2 sm:flex-row sm:items-center"
          >
            <div className="flex flex-1 items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3">
              <i className="ri-quill-pen-line text-foreground-400"></i>
              <input
                value={text}
                onChange={(e) => setText(e.target.value)}
                placeholder="在楼下跟一句，说说你的看法…"
                className="h-11 w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
              />
            </div>
            <button
              type="submit"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600"
            >
              <i className="ri-send-plane-fill mr-1.5"></i>跟楼评论
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}